import { createI18n } from "vue-i18n"
import translations from "@/translations"
import { uiTranslations } from "@projetsolaire/ui"

const mergedTranslations = {
  en: { ...translations.en, ...uiTranslations.en },
  fr: { ...translations.fr, ...uiTranslations.fr },
}

/**
 * Extract base locale from locale-region format
 * Examples: "fr-FR" -> "fr", "en-FR" -> "en", "fr" -> "fr"
 * @param {string} localeRegion - Locale in format "locale-region" or just "locale"
 * @returns {string} Base locale code
 */
export function getBaseLocale(localeRegion) {
  if (!localeRegion) return "fr"
  // If it contains a hyphen, extract the part before it
  const parts = localeRegion.split("-")
  return parts[0] || "fr"
}

const i18n = createI18n({
  legacy: false,
  locale: "fr",
  fallbackLocale: "fr",
  formatFallbackMessages: true,
  messages: mergedTranslations,
})

export default i18n
